export const USERS_FILTER_NAME = {
  industry: 'industry',
  companyName: 'company_name',
  website: 'website'
}



// WEBPACK FOOTER //
// ./src/js/const/filters.const.js